import React, { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import BorderNav from "./BorderNav";
import BorderTabContent from "./BorderTabContent";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { BorderTabsTitle } from "../../../../Constants/Constants";
import { BorderTabsSubTitle } from "../../../../Data/UiKits/Tabs";

const BorderTabs = () => {
  const [basicTab, setBasicTab] = useState("2");

  return (
    <Col xxl="6">
      <Card>
        <CommonCardHeader title={BorderTabsTitle} span={BorderTabsSubTitle} />
        <CardBody>
          <BorderNav basicTab={basicTab} setBasicTab={setBasicTab} />
          <BorderTabContent tabId={basicTab} />
        </CardBody>
      </Card>
    </Col>
  );
};
export default BorderTabs;
